// src/utils/uploadImage.js
import { API_BASE_URL } from '../config/apiConfig';

export const uploadImage = async (file, section = 'about') => {
  const formData = new FormData();
  formData.append('image', file);
  formData.append('section', section);

  const res = await fetch(`${API_BASE_URL}/upload`, {
    method: 'POST',
    body: formData,
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || 'Image upload failed');
  return data.data.url;
}; 